var $f95dc783f4af1258$exports = {};
$f95dc783f4af1258$exports = {
    "maximum": `Maksimaalne`,
    "minimum": `Minimaalne`
};


export {$f95dc783f4af1258$exports as default};
//# sourceMappingURL=et-EE.module.js.map
